import React from "react";

/** Bootstrap card family — Card, CardHeader, CardBody, CardFooter. */

export const Card = ({ small = false, className = "", style, children, ...rest }) => (
  <div className={["card", small && "card-small", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </div>
);

export const CardHeader = ({ className = "", style, children, ...rest }) => (
  <div className={["card-header", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </div>
);

export const CardBody = ({ className = "", style, children, ...rest }) => (
  <div className={["card-body", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </div>
);

export const CardFooter = ({ className = "", style, children, ...rest }) => (
  <div className={["card-footer", className].filter(Boolean).join(" ")} style={style} {...rest}>
    {children}
  </div>
);
